import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<form>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<form>` Element.
 *
 * Erstelle ein neues HTML `<form>` Element.
 *
 * ```typescript
 * import { Form } from "components/common/form";
 *
 * const form = new Form();
 * ```
 *
 * Konfiguriere das HTML `<form>` Element durch Method Chaining.
 *
 * ```typescript
 * form
 *     .withID("form")
 *     .withClass("form");
 * ```
 *
 * Rendere nun das HTML `<form>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(form.render());
 * ```
 *
 * @public
 */
class Form extends Component<HTMLFormElement> {
  /**
   * Erstellt ein neues HTML `<form>` Element.
   */
  constructor() {
    super(document.createElement("form"));
  }
}

export { Form };
